import { render, staticRenderFns } from "./job.vue?vue&type=template&id=5108a0e2&scoped=true&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108a0e2",
  null
  
)

export default component.exports